import BannerPage from "../page/Banner/BannerPage";
import OrderPage from "../page/Inquiry/InquiryPage";
import CertificatePage from "../page/Certificate/CertificatePage";
import InquiryPage from "../page/Inquiry/InquiryPage";
import ApplyTestPage from "../page/ApplyTest/ApplyTestPage";
import UserPage from "../page/User/UserPage";
import PaymentPage from "../page/Payment/PaymentPage";
import BasicSettingPage from "../component/Setting/Setting/BasicSettingPage";
import BasicTypePage from "../component/Certificate/BasicTypePage";
import CertificateTypePage from "../page/CertificateType/CertificateTypePage";


export const menus = [
  {
    mainMenu: { title: "사용자", path: "user" },
    subMenus: [
      {
        title: "사용자 목록",
        path: "user",
        page: <UserPage />,
      },
      {
        title: "구매 자격 관리",
        path: "certificate",
        page: <CertificatePage />,
      },
      // {
      //   title: "구매 자격 종류 관리",
      //   path: "certificate-type",
      //   page: <BasicTypePage />,
      // },
      {
        title: "구매 자격 종류 관리",
        path: "certificate-type2",
        page: <CertificateTypePage />,
      },
    ],
  },
  {
    mainMenu: { title: "문의 및 의뢰", path: "inquiry" },
    subMenus: [
      {
        title: "문의 및 의뢰 관리",
        path: "inquiry",
        page: <InquiryPage />,
      }
    ],
  },
  {
    mainMenu: { title: "인증코드 관리", path: "code" },
    subMenus: [
      {
        title: "인증코드 관리",
        path: "code",
        page: <ApplyTestPage />,
      },
    ],
  },
  {
    mainMenu: { title: "환경 설정", path: "setting" },
    subMenus: [
      {
        title: "배너 관리",
        path: "banner",
        page: <BannerPage />,
      },
      {
        title: "환경 설정",
        path: "setting",
        page: <BasicSettingPage />,
      },
    ],
  },
  {
    mainMenu: { title: "결제 관리", path: "payment" },
    subMenus: [
      {
        title: "결제 관리",
        path: "payment",
        page: <PaymentPage />,
      },
    ],
  },
];
